import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { userManager } from './oidcConfig';

const OidcSignInCallback = () => {
    const history = useHistory();
    useEffect(() => {
        console.log('signinRedirectCallback');
        userManager.signinRedirectCallback().then((user) => {
            console.log('signinRedirectCallback then', { user });
            // window.location.replace('/');
            const redirectUrl = (user?.state as { redirectUrl: string })?.redirectUrl || '/';
            window.history.replaceState(
                {},
                window.document.title,
                window.location.origin + window.location.pathname
            );
            history.push(redirectUrl);
        });
    }, [useHistory]);

    return <p>Loading...</p>;
};

export default OidcSignInCallback;
